export default class CategoryEntity {
    static getEntityData(elem: any) {
        return {
            uuid: elem.querySelector("#ticket_category_uuid") ? (elem.querySelector("#ticket_category_uuid") as HTMLInputElement).value : null,
            name: (elem.querySelector("#ticket_category_name") as HTMLInputElement).value,
        }
    }
}